import { type QuotaType } from '@/legacy-src/hooks/api/useGetCompanyQuota'

export const getCompanyServices = (quotas: QuotaType[]) => {
  if (!quotas) {
    return []
  }

  const allServices: number[] = []
  quotas.forEach((obj) => {
    allServices.push(...obj.services)
  })

  return allServices.filter((value, index, array) => array.indexOf(value) === index)
}
